import React, { useState, useEffect, useRef } from 'react';
import { animated, useSpring } from 'react-spring';

import { ReactComponent as DoneImg } from 'assets/img/done-img.svg';

const DoneView = ({ setXTransition, setYTransition, isId }) => {
  const ref = useRef();
  const [start, set] = useState(false);

  const doneImgProps = useSpring({
    opacity: start ? 1 : 0,
    transform: `translate(${start ? '0px, 0px' : '-150px, 150px'})`,
  });

  useEffect(() => {
    const main = ref.current;
    if (!main) return;
    const intersectionOptions = {
      threshold: 0.3,
    };
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        set(entry.isIntersecting);
        if (entry.isIntersecting) {
          obs.unobserve(main);
        }
      });
    }, intersectionOptions);
    observer.observe(main);
    return () => {
      observer.unobserve(main);
    };
  }, [ref]);

  return (
    <main ref={ref} className="done h-100vh flex flex-col">
      <div className="container h-100 flex flex-col">
        <div className="center-container">
          <animated.div style={doneImgProps}>
            <DoneImg />
          </animated.div>
          <h1>{isId ? 'Selesai' : 'Well Done'}</h1>
          <p>
            {isId
              ? 'Pantau kotak masuk email Anda. Kami akan menghubungi Anda ketika versi beta diluncurkan!'
              : 'Keep an 👁 on your inbox. We’ll reach out to you once the beta version is live!'}
          </p>
        </div>
        <button
          onClick={() => {
            setYTransition('translateY(0)');
            setXTransition('translateX(0)');
          }}
          className="button full mt-auto thick"
        >
          {isId ? 'Mengerti' : 'Got it'}
        </button>
      </div>
    </main>
  );
};

export default DoneView;
